import * as API from "./api";

/**
 * Toggle preventing the body from scrolling
 * @param {boolean} force Wether to activate or deactivate scroll
 */
export function toggleNoScroll(force) {
  document.body.classList.toggle("has-overflow-hidden", force);
}

/**
 * Listens to clicks on elements with a `data-action` attribute and calls the
 * callback when the action is clicked.
 *
 * @param {String} action The value of the data-attribute expected to be clicked
 * @param {Function} callback The callback to be called when the action is clicked
 * @param {EventSource} context The element to listen to (defaults to `document`)
 */
export function onDataActionClick(action, callback, context = document) {
  context.addEventListener("click", (event) => {
    const el = event.target.closest(`[data-action='${action}']`);
    if (!el) return;

    const targetSelector = el.dataset.target;
    const target = document.querySelector(targetSelector);

    callback({ el, target, event });
  });
}

/**
 * Render the result of fetching a URL into a container.
 * Usually works in pair with Elixir's `ConnUtils.render_raw_html/3` function.
 *
 * @param {Object} opts
 * @param {String} opts.url - The URL to fetch
 * @param {HTMLElement} opts.container - The container to render the fetched content
 * @returns {Promise<void>}
 */
export async function swap(opts) {
  const { url, container } = opts;

  const response = await API.fetch(url);

  if (!response.ok) {
    throw new SwapError("Error while fetching", { response });
  }

  container.innerHTML = await response.text();
}

class SwapError extends Error {
  constructor(message, details) {
    super(message);

    this.details = details;
  }
}
